import NavigationBar from '@/components/layout/navigation-bar/navigation-bar';
import { ROUTE_PPRA_PAYMENT } from '@/constants/routes';
import useStickyButton from '@/hooks/use-sticky-button';
import useOnMount from '@/hooks/useOnMount';
import { useSetIntercomIsVisible } from '@/queries/layout.queries';
import { Box } from '@cmpsr/components';
import { AdditionalInformation, StickyButton, TopSection } from './components';
import { CTA_TEXT } from './components/main-cta/MainCTA';
interface PPRAResultsScreenProps {
  results?: {
    riskScore: number;
    factorsIncreasingRiskCount: number;
    factorsDecreasingRiskCount: number;
  };
  ctaLink?: string;
}

export function PPRAResultsScreen({ results, ctaLink = ROUTE_PPRA_PAYMENT }: PPRAResultsScreenProps) {
  const { showStickyButton, mainButtonRef } = useStickyButton();
  const setIntercomIsVisible = useSetIntercomIsVisible();

  useOnMount(() => {
    setIntercomIsVisible.mutate(false);
    return () => {
      setIntercomIsVisible.mutate(true);
    };
  });

  return (
    <Box data-testid="ppra-results-screen" width="100%" minHeight="100vh" display="flex" flexDirection="column">
      <NavigationBar beta={true} />
      <TopSection mainCTARef={mainButtonRef} riskScore={results?.riskScore} ctaLink={ctaLink} />

      <AdditionalInformation />
      {showStickyButton && <StickyButton ctaText={CTA_TEXT} ctaLink={ctaLink} />}
    </Box>
  );
}

export default PPRAResultsScreen;
